
import {Component, Vue} from 'vue-property-decorator'
import {getGoodsSpecificationList, PackageListDto} from "@/api/buyCar";
import {SelectGoodsOptionsDto} from "@/api/commonConfig";
import { Action } from 'vuex-class'

@Component({
    name: 'BuyCarDialog'
})
export default class BuyCarDialog extends Vue {
  @Action setSelectList!: (val: SelectGoodsOptionsDto[]) => void;
    showTemp = false
    customerId = ''
    shopId = ''
    packageId = ''
    oldPackageId = ''
    goodsName = ''
    packageList: PackageListDto[] = []
    packageData: SelectGoodsOptionsDto = {}
    selectGoodsList: SelectGoodsOptionsDto[] = [] // 购物车中已选择的商品列表

    show(options: { customerId: string; shopId: string; goodsName: string; data: SelectGoodsOptionsDto, selectGoodsList: SelectGoodsOptionsDto[] }) {
        this.customerId = options.customerId
        this.goodsName = options.goodsName
        this.shopId = options.shopId
        this.packageId = options.data.packageId
        this.oldPackageId = options.data.packageId
        // 修改点击商品套餐时,商品列表的当前商品价格和套餐名称跟着变动的bug
        this.packageData =JSON.parse(JSON.stringify(options.data))
        this.packageData.mainImageUrl = options.data.imageNameUrl
        this.selectGoodsList = options.selectGoodsList
        this.getPackageList()
        this.showTemp = true
        console.log('options.data',options.data)
    }

    hide() {
        this.showTemp = false
    }

    getPackageList() {
        const params = {
            customerId: this.customerId,
            shopId: this.shopId,
            goodsId: this.packageData.goodsId
        }
        getGoodsSpecificationList(params).then((res) => {
            this.packageList = res.data.packageList || []
        })
    }

    sureFunc() {
        // console.log(this.packageData)
        if (this.selectGoodsList && this.selectGoodsList.length > 0) {
            const existIndex = this.selectGoodsList.findIndex(item => item.packageId === this.packageData.packageId)
            if (existIndex !== -1) {
                const max = this.packageData.maximum || 999999
                if (this.selectGoodsList[existIndex].saleAmount >= max) {
                    return this.$toast({
                        message: '当前商品套餐数量已达上限',
                        className: 'z10000'
                    })
                }
            }
        }
        this.packageData.imageNameUrl = this.packageData.mainImageUrl
        this.packageData.goodsName = this.goodsName
        this.$emit('getPackageData', this.packageData)
        this.hide()
    }

    resetFunc() {
        this.hide()
    }

    changeTag(data: PackageListDto) {
        // this.packageData = JSON.parse(JSON.stringify(data))
        this.packageId = data.packageId
        Object.assign(this.packageData, data)
        /* 起定量和限定量存在不返回的情况 */
        this.packageData.minimum = data.minimum
        this.packageData.maximum = data.maximum
        this.packageData.saleAmount = data.minimum
    }
}
